// show/hide are you sure message on radio button change.
document.addEventListener('change', (event) => {
  const radioInput = event.target.closest('.join-organisation-field-wrapper input[type="radio"]')
  if (!radioInput) return

  const areYouSureMessage = document.querySelector('.join-organisation-field-wrapper .radio-are-you-sure-message')
  if (!areYouSureMessage) return

  const checkedRadio = document.querySelector('.join-organisation-field-wrapper input[type="radio"]:checked')
  if (checkedRadio?.value === 'true') {
    areYouSureMessage.style.display = 'none'
  } else {
    areYouSureMessage.style.display = 'block'
  }
})

